/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationsCreatePortalSession } from "../funcs/organizationsCreatePortalSession.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { CreatePortalSessionResult } from "../models/components/createportalsessionresult.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreatePortalSessionRequest,
  CreatePortalSessionSecurity,
} from "../models/operations/createportalsession.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreatePortalSessionMutationVariables = {
  request?: CreatePortalSessionRequest | undefined;
  security?: CreatePortalSessionSecurity | undefined;
  options?: RequestOptions;
};

export type CreatePortalSessionMutationData = CreatePortalSessionResult;

export type CreatePortalSessionMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createPortalSession organizations
 *
 * @remarks
 * Create a webhook portal session.
 */
export function useCreatePortalSessionMutation(
  options?: MutationHookOptions<
    CreatePortalSessionMutationData,
    CreatePortalSessionMutationError,
    CreatePortalSessionMutationVariables
  >,
): UseMutationResult<
  CreatePortalSessionMutationData,
  CreatePortalSessionMutationError,
  CreatePortalSessionMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreatePortalSessionMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreatePortalSession(): MutationKey {
  return ["@gram/client", "organizations", "createPortalSession"];
}

export function buildCreatePortalSessionMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreatePortalSessionMutationVariables,
  ) => Promise<CreatePortalSessionMutationData>;
} {
  return {
    mutationKey: mutationKeyCreatePortalSession(),
    mutationFn: function createPortalSessionMutationFn({
      request,
      security,
      options,
    }): Promise<CreatePortalSessionMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(organizationsCreatePortalSession(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
